export default __webpack_public_path__ + "static/media/headphone.8b4393f8.svg";